<button class="btn btn-secondary" (click)="nextCaptureClick()" [disabled]="isDisabled">
  <fa-icon *ngIf="isDisabled" [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
  NEXT
</button>
